import { Routes } from "@angular/router";

export const publicPresenceRoutes: Routes = [
  {
    path: "",
    pathMatch: "full",
    loadComponent: () =>
      import("./mobile-public-presence-page/mobile-public-presence-page.component").then(
        (moduleExports) => moduleExports.MobilePublicPresencePageComponent
      ),
  },
  {
    path: ":token",
    loadComponent: () =>
      import("./mobile-public-presence-page/mobile-public-presence-page.component").then(
        (moduleExports) => moduleExports.MobilePublicPresencePageComponent
      ),
  },
];
